var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcnCanceledService(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 99.488,
    height: 99.171,
    viewBox: "0 0 99.488 99.171",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "circle",
    x: 0,
    y: 0,
    width: 99.488,
    height: 99.171,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.078
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn-canceled-service",
    transform: "translate(9 6)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#circle)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "circle-2",
    "data-name": "circle",
    cx: 40.744,
    cy: 40.586,
    rx: 40.744,
    ry: 40.586,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "dots",
    transform: "translate(-0.373 0.702)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16132",
    "data-name": "Group 16132",
    transform: "translate(-33 -21)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1262",
    "data-name": "Ellipse 1262",
    cx: 1.16,
    cy: 1.155,
    rx: 1.16,
    ry: 1.155,
    transform: "translate(56.15 88.221)",
    fill: "#e7e6e6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1263",
    "data-name": "Ellipse 1263",
    cx: 1.16,
    cy: 1.155,
    rx: 1.16,
    ry: 1.155,
    transform: "translate(47.443 36.88)",
    fill: "#8c94c9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1264",
    "data-name": "Ellipse 1264",
    cx: 1.16,
    cy: 1.155,
    rx: 1.16,
    ry: 1.155,
    transform: "translate(42.611 64.432)",
    fill: "#97d3f1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16131",
    "data-name": "Group 16131",
    transform: "translate(-22 -14)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1265",
    "data-name": "Ellipse 1265",
    cx: 1.16,
    cy: 1.155,
    rx: 1.16,
    ry: 1.155,
    transform: "translate(81.357 79.38)",
    fill: "#8c94c9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1266",
    "data-name": "Ellipse 1266",
    cx: 1.16,
    cy: 1.155,
    rx: 1.16,
    ry: 1.155,
    transform: "translate(89.932 47.762)",
    fill: "#97d3f1"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1267",
    "data-name": "Ellipse 1267",
    cx: 1.16,
    cy: 1.155,
    rx: 1.16,
    ry: 1.155,
    transform: "translate(62.533 16.227)",
    fill: "#e7e6e6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "icn-deceptors",
    transform: "translate(-123.807 83.026)",
    opacity: 0.995
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16820",
    "data-name": "Group 16820",
    transform: "translate(-1171.638 -135.185)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12296",
    "data-name": "Path 12296",
    d: "M0,0A6.867,6.867,0,0,0,2.125,3.769c2.182,2.254,2.758,2.014,8,1.746,5.672-.292,13.6,3.054,14.4,4.872H.016S-.009.084,0,0Z",
    transform: "translate(1332.57 76.477) rotate(90)",
    fill: "#0eb4d0",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12303",
    "data-name": "Path 12303",
    d: "M0,0S.142,1.127,2.125,2.469c2.182,1.477,2.758,1.319,8,1.144,5.672-.191,13.6,2,14.4,3.192H.016S-.009.055,0,0Z",
    transform: "translate(1327.376 76.477) rotate(90)",
    fill: "#0eb4d0",
    opacity: 0.175
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_12413",
    "data-name": "Path 12413",
    d: "M1222.758,15.6h-6.264c-.206,0-.373-.352-.373-.786s.167-.786.373-.786h6.264c.206,0,.373.352.373.786S1222.964,15.6,1222.758,15.6Z",
    transform: "translate(-1047.809 -76.896)",
    fill: "#0eb4d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12414",
    "data-name": "Path 12414",
    d: "M1232.973,19.581h-6.9c-.206,0-.373-.352-.373-.787s.167-.785.373-.785h6.9c.206,0,.373.352.373.785S1233.179,19.581,1232.973,19.581Z",
    transform: "translate(-1052.525 -77.636)",
    fill: "#0eb4d0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_17007",
    "data-name": "Group 17007",
    transform: "translate(-854.305 -295.168)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20914",
    "data-name": "Path 20914",
    d: "M1031.7,247.874c-2.2,0-4.242-.006-6.284,0a4.4,4.4,0,0,1-4.725-4.682c-.011-1.974-.009-3.949-.016-5.923a2.037,2.037,0,0,0-.085-.335c-.3-.015-.643-.047-.986-.048q-5.924-.006-11.847,0a2.266,2.266,0,0,0-2.529,2.521q-.019,12.924-.008,25.848a2.226,2.226,0,0,0,2.431,2.4c4.236.018,8.472.007,12.708.018.943,0,1.607.559,1.325,1.206a1.715,1.715,0,0,1-1.212.917c-4.379.067-8.76.1-13.138.023a4.307,4.307,0,0,1-4.285-4.363q-.013-13.032.008-26.063a4.356,4.356,0,0,1,4.728-4.676c4.667-.011,9.334-.019,14,.021a2.225,2.225,0,0,1,1.4.544q5.047,4.85,10,9.795a2.488,2.488,0,0,1,.664,1.561c.059,3.23.035,6.462.022,9.693,0,1.036-.716,1.732-1.4,1.312a1.868,1.868,0,0,1-.735-1.35C1031.667,253.534,1031.7,250.775,1031.7,247.874Zm-1.521-2.183-7.284-7.411c0,1.9-.049,3.751.02,5.6a2.012,2.012,0,0,0,1.972,1.8C1026.672,245.728,1028.457,245.691,1030.18,245.691Z",
    fill: "#007c9f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17133",
    "data-name": "Rectangle 17133",
    width: 9.824,
    height: 2.27,
    rx: 1.135,
    transform: "translate(1007.852 242.379)",
    fill: "#0eb4d0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17134",
    "data-name": "Rectangle 17134",
    width: 9.824,
    height: 2.27,
    rx: 1.135,
    transform: "translate(1007.852 247.806)",
    fill: "#0eb4d0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17135",
    "data-name": "Rectangle 17135",
    width: 15.99,
    height: 2.27,
    rx: 1.135,
    transform: "translate(1007.852 253.234)",
    fill: "#0eb4d0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17136",
    "data-name": "Rectangle 17136",
    width: 15.99,
    height: 2.27,
    rx: 1.135,
    transform: "translate(1007.852 258.661)",
    fill: "#0eb4d0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17137",
    "data-name": "Rectangle 17137",
    width: 17.918,
    height: 2.27,
    rx: 1.135,
    transform: "translate(1027.523 256.1) rotate(45)",
    fill: "#0eb4d0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17138",
    "data-name": "Rectangle 17138",
    width: 17.918,
    height: 2.27,
    rx: 1.135,
    transform: "translate(1040.076 257.705) rotate(135)",
    fill: "#0eb4d0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_12415",
    "data-name": "Path 12415",
    d: "M1224.011,15.6h-7.446c-.245,0-.444-.352-.444-.786s.2-.786.444-.786h7.446c.245,0,.444.352.444.786S1224.256,15.6,1224.011,15.6Z",
    transform: "translate(-1079.422 -57.622)",
    fill: "#0eb4d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12416",
    "data-name": "Path 12416",
    d: "M1234.346,19.581h-8.2c-.245,0-.444-.352-.444-.787s.2-.785.444-.785h8.2c.245,0,.444.352.444.785S1234.591,19.581,1234.346,19.581Z",
    transform: "translate(-1083.221 -58.362)",
    fill: "#0eb4d0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnCanceledService);
export default __webpack_public_path__ + "static/media/icn-canceled-service.d3ef3c8914b83cd0b8f892d9fa81cd06.svg";
export { ForwardRef as ReactComponent };